// Models
import { createAppStoreDefaultModel } from './app/app.store'
import { createGeneralStoreDefaultModel } from './general/general.store'
import { createLocalizationStoreDefaultModel } from './localization/localization.store'

const etcModels = {
  app: createAppStoreDefaultModel(),
  general: createGeneralStoreDefaultModel(),
  localization: createLocalizationStoreDefaultModel(),
}

export { etcModels }
